export default {
  UserInformation: '/carrier/user/read',
  ChangePassword: '/carrier/user/change-password',
  ChangeEmail: '/carrier/user/change-email',
  UpdateUserInfo: '/carrier/user/update',
  UpdateUserPhoto: '/carrier/user/patch',

  carrierInformation: '/carrier/info',
  updateCarrierInformation: '/carrier/info/update'
}
